"use strict";
angular.module("addOrEditTwoTagServiceModule", [
    "addOrEditTwoTagModule", //新建、编辑标签
]).
factory("addOrEditTwoTagService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [addOrEditTag description] 新建、编辑标签
         * @param {[string]} [tagId,tagName] [description] 
         */
        addOrEditTwoTag: function(tagId,tagName,parentId,channelId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/pgcManage/labelManagement/twoLevelLabel/service/addOrEditTwoTag/addOrEditTwoTag_tpl.html",
                windowClass: 'addOrEditTwoTag backstageModalHeader',
                backdrop: false,
                controller: "addOrEditTwoTagCtrl",
                resolve: {
                    tagId : function(){
                    	return tagId;
                    },
                    tagName : function(){
                    	return tagName;
                    },
                	parentId :function(){
                		return parentId;
                	},
                	channelId : function(){
                		return channelId;
                	},
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);